import React, { useEffect } from "react";
import { RoundCard, RunnerUpHeader, TableWork } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useState } from "react";
import { useGetEpbScanningCeoReportQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State name",
  "District No. and Name",
  "AC/PC No. and Name",
  "Total e-PB valid",
  "Total e-PB invalid",
  "Total e-PB manually Rejected",
  "Total e-PB found duplicate",
  "Incomplete Scanned",
  "Total e-PB Scannned",

];

const selectConstituencyType = [
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];

const EpbScanningCeoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
 
  const [data, setData] = useState({
    constituencyType: "AC",
  });
  const [tabledata, setTabledata] = useState([]);
  const [skip, setskip] = useState(false);
  const reportName = "e-Postal Ballot PreCounting Report"
  const SheetName = "Scanning Report"
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "District No. and Name",
      accessor: "col2",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Total e-PB valid",
      accessor: "col4",
    },
    {
      Header: "Total e-PB invalid",
      accessor: "col5",
    },
    {
      Header: "Total e-PB manually Rejected",
      accessor: "col6",
    },
    {
      Header: "Total e-PB found duplicate",
      accessor: "col7",
    },
    {
      Header: "Incomplete Scanned",
      accessor: "col8",
    },
    {
      Header: "Total e-PB Scannned",
      accessor: "col9",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const { data: responseData, isLoading: isLoading } =
    useGetEpbScanningCeoReportQuery(data.constituencyType, {
      skip: skip,
      refetchOnMountOrArgChange: true,
    });

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setskip(false);
  };

  useEffect(() => {
    var tableData = [];
    if (responseData != null) {
      responseData?.payload?.map((item) => {
        tableData.push({
          "col1": item.stateName,
          "col2": `${item.districtCd}-${item.districtName}`,
          "col3": `${item.acPcNo}-${item.acPcName}`,
          "col4": item.validEpbScannigCount,
          "col5": item.invalidEpbScannigCount,
          "col6": item.manuallyRejectedEpbCount,
          "col7": item.duplicateEpbScannigCount,
          "col8": item.incompleteCount,
          "col9": item.totalCount,

        });
      });
      setTabledata(tableData);
      setTotalNoOfRecords(responseData?.payload?.length)
      setskip(true);
    }
  }, [responseData]);

  return (
    <LeftMenu>
    <div className="container box shadow ">
      <RunnerUpHeaderNew title={reportName} 
      state={  <span
                  >
                    State: {responseData?.state}{" "}
                    </span>}
          
         onPdfClick={() => downloadPdfFile(reportName, tableHeader, tabledata, false, true)} 
         onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tabledata, true)} />
      <div className="row">
        <SelectField
          labelClass=""
          inputClass="col-md-2"
          value={data.constituencyType}
          handleChange={(val) => handleChange("constituencyType", val)}
          options={selectConstituencyType}
        />
      </div>
      <div style={{ marginTop: "-40px" }}>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          records
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </div>
   </LeftMenu>
  );
};
export default EpbScanningCeoReport;
